import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { EntityMap } from '@shared/models/types';
import { OrgDetails } from '@shared/models/org-details.model';
import { SharedOrganizationService } from '@shared/services/shared-organization.service';
import { FetchCustomerOrgDetails } from './customer-org-details.actions';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

export interface CustomerOrgDetailsStateModel {
  customerOrgDetails: EntityMap<string, { logo: string; orgName: string }>;
}

export const customerOrgDetailsStateKey = 'customerOrgDetails';

export const getInitialCustomerOrgDetailsState = (): CustomerOrgDetailsStateModel => ({
  customerOrgDetails: {}
});

@State<CustomerOrgDetailsStateModel>({
  name: customerOrgDetailsStateKey,
  defaults: getInitialCustomerOrgDetailsState()
})
@Injectable()
export class CustomerOrgDetailsState {
  constructor(private sharedOrganizationService: SharedOrganizationService) {}

  @Selector()
  static getCustomerOrgDetails(state: CustomerOrgDetailsStateModel): EntityMap<string, { logo: string; orgName: string }> {
    return state.customerOrgDetails;
  }

  @Action(FetchCustomerOrgDetails)
  fetchCustomerOrgDetails(
    { patchState, getState }: StateContext<CustomerOrgDetailsStateModel>,
    { orgId }: FetchCustomerOrgDetails
  ) {
    const state = getState();
    
    // Check if already fetched
    if (state.customerOrgDetails[orgId]) {
      return;
    }

    return this.sharedOrganizationService.getOrgDetails([orgId]).pipe(
      tap((orgDetails: OrgDetails[]) => {
        if (orgDetails && orgDetails.length > 0) {
          const details = orgDetails[0];
          patchState({
            customerOrgDetails: {
              ...state.customerOrgDetails,
              [orgId]: {
                logo: details.logo,
                orgName: details.orgName
              }
            }
          });
        }
      }),
      catchError((error) => {
        console.error('Error fetching customer org details:', error);
        return of(null);
      })
    );
  }
}

